import { Controller } from "@hotwired/stimulus"

// Slide-in + auto-dismiss toast for "AI insights ready" notifications.
// Class transitions mirror the standard `showToast()` pattern in
// app/views/shared/_toast_notification.html.erb so the animation is identical
// to flash-based toasts.
export default class extends Controller {
  static values = { duration: { type: Number, default: 12000 } }

  connect() {
    requestAnimationFrame(() => {
      this.element.classList.remove("translate-x-full", "opacity-0")
      this.element.classList.add("translate-x-0", "opacity-100")
    })
    this.timer = setTimeout(() => this.dismiss(), this.durationValue)
  }

  disconnect() {
    if (this.timer) clearTimeout(this.timer)
  }

  dismiss() {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
    this.element.classList.remove("translate-x-0", "opacity-100")
    this.element.classList.add("translate-x-full", "opacity-0")
    setTimeout(() => this.element.remove(), 300)
  }
}
